// CancelIRNForm.js - Fully Auto-Populated & Transparent (IRIS GST Style)
import React, { useState, useEffect } from 'react';
import { useAuth } from "../../components/AuthContext";
const CancelIRN  = ({ previousResponse }) => {
   const { token, companyId } = useAuth();
  const STORAGE_KEY1  = "iris_einvoice_shared_config";
  const LAST_IRN_KEY = "iris_last_generated_irn";
  const STORAGE_KEY2 = "iris_einvoice_irn_ewabill";
  
  const savedConfig1 = JSON.parse(localStorage.getItem(STORAGE_KEY1) || '{}');
  const savedConfig = JSON.parse(localStorage.getItem(STORAGE_KEY2) || '{}');

 console.log("savedConfig1",savedConfig1)
 console.log("savedConfig",savedConfig)


  // Deduplicated IRN sourcing
  const irn = previousResponse?.irn || savedConfig?.irn || '';
  console.log("irn",irn)
  const initialGstin = savedConfig1?.companyUniqueCode
    || savedConfig?.companyUniqueCode
    || savedConfig?.userGstin
    || "";
  const initialCompanyCode = savedConfig1?.companyUniqueCode
    || savedConfig?.companyUniqueCode
    || previousResponse?.userGstin
    || "";
  console.log("initialGstin ",initialGstin )
    console.log("initialCompanyCode",initialCompanyCode)

const [config, setConfig] = useState({
  proxyBase: "https://einvoice.fcssoftwares.com",
  endpoint: "/api/gst/einvoice/cancel-irn",
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    companyId: companyId,
    "X-Auth-Token": token,
    product: "ONYX",
  },
  body: {
    irn: irn,
    cnlRsn: "1", // 1=Wrong Entry, 2=Duplicate, 3=Order Cancelled, 4=Others
    cnlRem: "Wrong entry",
    userGstin: initialGstin ,
  },
});
  const [response, setResponse] = useState(null);
  const [loading, setLoading] = useState(false);

 useEffect(() => {
  setConfig((prev) => ({
    ...prev,
    headers: {
      ...prev.headers,
      companyId: companyId || "",
      "X-Auth-Token": token || "",
    },
  }));
}, [token, companyId]);

  const cancelIRN = async () => {
    if (!config.body.irn.trim() || config.body.irn.length !== 64) {
      alert('Please enter a valid 64-character IRN');
      return;
    }
    if (!config.body.cancelRem.trim()) {
      alert('Please enter cancellation remark');
      return;
    }
    if (!config.headers.companyId || !config.headers['X-Auth-Token']) {
      alert('Authentication required. Please set companyId and X-Auth-Token.');
      return;
    }
    setLoading(true);
    setResponse(null);
    try {
      const res = await fetch(`${config.proxyBase}${config.endpoint}`, {
        method: 'PUT',
        headers: config.headers,
        body: JSON.stringify(config.body)
      });
      const data = await res.json();
      const result = {
        status: res.status,
        statusText: res.statusText,
        body: data,
        time: new Date().toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' })
      };
      setResponse(result);

      if (res.ok && data.status === 'SUCCESS') {
        alert('IRN Cancelled Successfully!');
        localStorage.setItem( LAST_IRN_KEY, JSON.stringify({
          companyId: companyId,
          token: token,
        }));
        setConfig(prev => ({ ...prev, body: { ...prev.body, irn: '' } }));
      } else if (res.status === 401 || res.status === 403 || data.message?.includes('Unauth')) {
        alert(`Authentication failed: ${data.message || 'Invalid token/companyId'}. Please update credentials.`);
      } else {
        alert(`Cancellation failed: ${data.message || 'Unknown error'}`);
      }
    } catch (err) {
      console.error('Fetch error:', err);
      setResponse({
        error: err.message,
        status: 'NETWORK_ERROR',
        time: new Date().toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' })
      });
      alert('Network error. Check proxy server and try again.');
    } finally {
      setLoading(false);
    }
  };

  const updateHeader = (key, value) => {
    setConfig(prev => ({
      ...prev,
      headers: { ...prev.headers, [key]: value }
    }));
  };

  const isReady = config.headers.companyId && config.headers['X-Auth-Token'] && config.body.irn && config.body.cancelRem;

  const cancelReasons = {
    '1': '1 - Wrong Entry',
    '2': '2 - Duplicate',
    '3': '3 - Order Cancelled',
    '4': '4 - Others'
  };

  // Reusable style for inputs & selects
  const fieldRow = {
  display: "flex",
  alignItems: "center",
  marginBottom: "25px",
  gap: "20px",
};

const labelStyle = {
  width: "220px",
  fontWeight: "600",
  fontSize: "16px",
  color: "#333",
};

const inputStyle = {
  flex: 1,
  padding: "14px",
  border: "2px solid #ffb74d",
  borderRadius: "10px",
  fontSize: "16px",
  backgroundColor: "#fffde7",
};


  const headerInputStyle = {
    flex: 1,
    padding: '8px 12px',
    borderWidth: '2px',
    borderStyle: 'solid',
    borderColor: '#ffb74d',
    borderRadius: '6px',
    fontFamily: 'monospace',
    fontSize: '14px',
    backgroundColor: '#fffde7',
    color: '#000',
    wordBreak: 'break-all'
  };

  return (
  <div
    style={{
      padding: "30px",
      background: "#fffde7",
      fontFamily: "Segoe UI, Arial, sans-serif",
      minHeight: "100vh",
    }}
  >
    <h1
      style={{
        color: "#f57f17",
        marginBottom: "10px",
        fontSize: "36px",
      }}
    >
      Cancel IRN (E-Invoice)
    </h1>

    <p
      style={{
        color: "#666",
        fontSize: "16px",
        marginBottom: "30px",
      }}
    >
      All headers & payload visible before sending • Auto-filled from previous
      actions • Editable auth headers
    </p>

    <div
      style={{
        background: "white",
        padding: "40px",
        borderRadius: "20px",
        boxShadow: "0 14px 50px rgba(0,0,0,0.15)",
        maxWidth: "850px",
        margin: "0 auto",
      }}
    >
      <h2
        style={{
          color: "#f57f17",
          marginBottom: "35px",
        }}
      >
        Cancel IRN Details
      </h2>

      {/* IRN */}
      <div style={fieldRow}>
        <label style={labelStyle}>IRN (64 Characters)</label>

        <input
          value={config.body.irn}
          readOnly
          onChange={(e) =>
            setConfig((prev) => ({
              ...prev,
              body: {
                ...prev.body,
                irn: e.target.value,
              },
            }))
          }
          placeholder="Enter 64-character IRN"
          style={inputStyle}
        />
      </div>

      {/* Cancellation Reason */}
      <div style={fieldRow}>
        <label style={labelStyle}>Cancellation Reason</label>

        <select
          value={config.body.cancelRsn}
          onChange={(e) =>
            setConfig((prev) => ({
              ...prev,
              body: {
                ...prev.body,
                cancelRsn: e.target.value,
              },
            }))
          }
          style={inputStyle}
        >
          {Object.entries(cancelReasons).map(([code, label]) => (
            <option key={code} value={code}>
              {label}
            </option>
          ))}
        </select>
      </div>

      {/* Cancellation Remark */}
      <div style={fieldRow}>
        <label style={labelStyle}>Cancellation Remark</label>

        <input
          value={config.body.cancelRem}
          onChange={(e) =>
            setConfig((prev) => ({
              ...prev,
              body: {
                ...prev.body,
                cancelRem: e.target.value,
              },
            }))
          }
          placeholder="e.g. Wrong entry in invoice amount"
          style={inputStyle}
        />
      </div>

      <button
        onClick={cancelIRN}
        disabled={!isReady || loading}
        style={{
          width: "100%",
          padding: "22px",
          marginTop: "40px",
          background: !isReady || loading ? "#999" : "#f57f17",
          color: "white",
          border: "none",
          borderRadius: "14px",
          fontSize: "28px",
          fontWeight: "bold",
          cursor: !isReady || loading ? "not-allowed" : "pointer",
          boxShadow: "0 10px 30px rgba(245,127,23,0.35)",
        }}
      >
        {loading ? "Cancelling IRN..." : "CANCEL IRN"}
      </button>
    </div>

    {response && (
      <div style={{ marginTop: "60px" }}>
        <h2
          style={{
            color: "#e65100",
            borderBottom: "4px solid #ffb74d",
            paddingBottom: "12px",
          }}
        >
          RESPONSE ({response.time} IST) - Status: {response.status}{" "}
          {response.statusText || ""}
        </h2>

        <pre
          style={{
            background: "#1e1e1e",
            color: "#ff9100",
            padding: "35px",
            borderRadius: "18px",
            fontSize: "16px",
            marginTop: "25px",
            border: "3px solid #ffb74d",
          }}
        >
          {JSON.stringify(response.body || response.error || response, null, 2)}
        </pre>
      </div>
    )}

    <footer
      style={{
        marginTop: "100px",
        textAlign: "center",
        color: "#888",
        fontSize: "15px",
      }}
    >
      IRIS GST ONYX • Cancel IRN •{" "}
      {new Date().toLocaleString("en-IN", {
        timeZone: "Asia/Kolkata",
      })}{" "}
      IST
    </footer>
  </div>
);
};

export default CancelIRN ;
